import React, { useEffect } from 'react';
import { v4 as uuid } from 'uuid';
import { getFramework, HOTKEY_TYPE, useIdentity } from '@/framework';
import { IExportPlugin, PluginType } from '@/version-types';

const SelectAll: React.FC = React.memo(() => {
    const identity = useIdentity();

    useEffect(() => {
        const framework = getFramework(identity);
        const selectAllHandle = framework.events.on(HOTKEY_TYPE.selectAll, () => {
            framework.operate.delActiveLayer(false);
            const originIndex = framework.stage.getActiveOriginIndex();
            const layers = framework.getCollisionLayers(originIndex);
            if (layers.length === 0) return;
            if (layers.length === 1) {
                framework.operate.setActiveLayer(layers[0].id);
                framework.operate.delHoverId();
                return;
            }

            const pickIdsSet = new Set(layers.map((item) => item.id));
            const groupLayer = framework.tryCreateGroup(originIndex, uuid(), pickIdsSet);
            if (!groupLayer) return;

            framework.stage.addOrUpdate(groupLayer);
            framework.operate.setActiveLayer(groupLayer.id);
            framework.operate.delHoverId();
        });

        return () => {
            framework.events.off(selectAllHandle);
        };
    }, []);

    return null;
});

const exportPlugin: IExportPlugin = {
    type: PluginType.SYSTEM,
    sort: 1,
    name: 'hotkey-event-select-all',
    render() {
        return <SelectAll />;
    },
};

export default exportPlugin;
